import { ReactComponent as Dashboard } from "../Assets/Images/SidebarIcons/copy.svg";
import { ReactComponent as People } from "../Assets/Images/SidebarIcons/formkit_people.svg";
import { ReactComponent as Diagnos } from "../Assets/Images//SidebarIcons/Frame.svg";
import { ReactComponent as Referal } from "../Assets/Images/SidebarIcons/Frame-1.svg";
import { ReactComponent as Lock } from "../Assets/Images/SidebarIcons/Lock.svg";
import { FaBuilding, FaCommentsDollar, FaUserDoctor, FaFileContract } from "react-icons/fa6";
import { RxDashboard } from "react-icons/rx";
import { GiPriceTag } from "react-icons/gi";

import { LiaFilePrescriptionSolid } from "react-icons/lia";


export const menuItems = [
    {
        path: "/dashboard",
        include: "dashboard",
        label: "Dashboard",
        icon: <RxDashboard />,
        adminOnly: true,
    },
    {
        path: "/consultation-logs",
        include: "consult",
        label: "Consultation Logs",
        icon: <Dashboard />,
    },
    {
        path: "/patient-record",
        include: "patient",
        label: "Patient Record Management",
        icon: <People />,
    },
    {
        path: "/referral-management",
        include: "refer",
        label: "Referral Management",
        icon: <Referal />,
    },
    {
        path: "/prescribe-medicine",
        include: "prescribe",
        label: "Prescribe Meds",
        icon: <LiaFilePrescriptionSolid />,
        doctorOnly: true,
    },
    {
        path: "/diagnostic-center-management",
        include: "center",
        label: "Diagnostic Center",
        icon: <FaBuilding />,
        adminOnly: true,
    },
    {
        path: "/diagnostic-test-management",
        include: "test",
        label: "Diagnostic Test",
        icon: <Diagnos />,
        adminOnly: true,
    },
    {
        path: "/doctor-management",
        include: "doctor",
        label: "Doctor Management",
        icon: <FaUserDoctor />,
        adminOnly: true,
    },
    {
        path: "/call-history",
        include: "history",
        label: "Price Usage History",
        icon: <FaCommentsDollar />,
        adminOnly: true,
    },
    {
        path: "/call-rates",
        include: "rates",
        label: "Call Rates",
        icon: <GiPriceTag />,
        adminOnly: true,
    },
    {
        path: "/cms",
        include: "cms",
        label: "Content Management",
        icon: <FaFileContract />,
        adminOnly: true,
    },
    {
        path: "/change-password",
        label: "Change Password",
        icon: <Lock />,
    }
];